import { Component, Injectable, OnChanges, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { repeaterAnimation } from 'app/main/pages/invoice/invoice.animation';
import { TipoItemService } from '@core/services/tipo-item.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanoService } from '@core/services/plano.service';
import moment from 'moment';
import { ClienteService } from '@core/services/cliente.service';
import Swal from 'sweetalert2';
import { PedidoService } from '@core/services/pedido.service';
import { PedidoItemService } from '@core/services/pedido-item.service';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ActivatedRoute, Router } from '@angular/router';
import { DescontoService } from '@core/services/desconto.service';
import { PedidoInterface } from 'app/module/pedido-interface';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ProdutoInterface } from 'app/module/produto-interface';
import { ServicoInterface } from 'app/module/servico-interface';
import { TabelaPrecoService } from 'app/services/tabela-preco.service';
import { ContratoService } from 'app/services/contrato.service';
import { RastreadorModeloService } from 'app/services/rastreador-modelo.service';
import { UsuarioService } from '@core/services/usuario.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = '/';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
	}
}
@Component({
	selector: 'app-pedido-rastreador-form',
	templateUrl: './pedido-rastreador-form.component.html',
	styleUrls: ['./pedido-rastreador-form.component.scss'],
	animations: [repeaterAnimation],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{ provide: NgbDateAdapter, useClass: CustomAdapter },
		{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
	],
})
export class PedidoRastreadorFormComponent implements OnInit, OnDestroy, OnChanges {
	private timer: any;
	pedido: PedidoInterface = {
		id_pedido: null,
		id_status: null,
		id_cliente: null,
		id_sistema: null,
		dt_pedido: null,
		num_pedido: null,
		gerarNF: false,
		instalarPlataforma: false,
		chipRastreei: false,
		rastreadores: [],
	};
	apiData;
	sidebarToggleRef = false;
	tipoItem;
	indexItem;
	tipoItemSelecionado = [];
	contentHeader: object;
	planos;
	selectedCliente: any = null;
	termoPesquisa: string = '';
	carregando: boolean = false;
	clientes;
	valorTotal: number = 0;
	erro: boolean;
	loading: boolean;
	arrayPost = []
	temp: any;
	descontos;
	tempDescontos: any;
	starting: boolean = false;
	loadingContrato: boolean = false;
	form;
	clienteNaoEncontrado = false;
	desconto_selecionado = [];
	valorTotalComDesconto: number = 0;
	isValorFixo = true;
	isVisualizacao: boolean = false;
	modoEdicao = false;
	isProdutosCollapsed = false;
	isPedidoCollapsed: boolean = false;
	isSeparacaoCollapsed: boolean = true;
	isConfiguracaollapsed: boolean = true;
	isEnvioProntoCollapsed: boolean = true;
	imeisParaSeparacao: string = '';
	qrCodeImageUrl: SafeUrl;
	currentPageUrl: string = '';

	contrato = {
		dt_vencimento: '25',
		dt_fidelidade: null,
		gerar_nf: false,
		gerar_fatura: false,
		carencia: false,
		dt_carencia: null,
		id_contrato: null,
		num_contrato: null,
		dt_insert: null,
		dt_contrato: null,
		tempo_bloqueio: '15'
	}

	public itensPedidoProduto = [];

	public itensPedidoServico = [];

	public dateOptions = {
		altInput: true,
		mode: 'single',
		altInputClass: 'form-control flat-picker flatpickr-input invoice-edit-input',
		altFormat: "d/m/Y",
	};
	public ColumnMode = ColumnMode;

	private _unsubscribeAll: Subject<any>;
	tipoItemServico: ServicoInterface[];
	tipoItemproduto: ProdutoInterface[];
	itensTabelaPreco: any;
	itensModal: any;
	public modelosRastreador: any[] = [];

	// Replace the hardcoded vendedores with:
	vendedores: any[] = [];
	selectedVendedor: any = null;
	idComponet: any;

	necessitaConfiguracao: boolean = false;
	configuracao = {
		plataforma: 'rastreei',
		plataformaConfig: {
			dominio: '',
			porta: ''
		},
		chip: 'rastreei',
		chipConfig: {
			dominio: '',
			usuario: '',
			senha: ''
		}
	};

	constructor(
		private descontoService: DescontoService,
		private tabelaPrecoService: TabelaPrecoService,
		private pedidoItemService: PedidoItemService,
		private tipoItemService: TipoItemService,
		private planoService: PlanoService,
		private pedidoService: PedidoService,
		private clienteService: ClienteService,
		private contratoService: ContratoService,
		private modalService: NgbModal,
		private _router: Router,
		private route: ActivatedRoute,
		private rastreadorModeloService: RastreadorModeloService,
		private usuarioService: UsuarioService,
		private sanitizer: DomSanitizer
	) {
		this._unsubscribeAll = new Subject();
	}

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	async ngOnInit() {

		this.form = new FormGroup({
			dt_contrato: new FormControl(),
			dt_fidelidade: new FormControl()
		});

		try {
			this.vendedores = await this.usuarioService.findAll();
		} catch (error) {
			console.error('Erro ao carregar vendedores:', error);
		}

		// Get ID from route if exists
		const id = this.route.snapshot.params['id'];
		this.modoEdicao = id == undefined ? false : true;
		this.idComponet = id;

		if (id) {
			try {
				const pedido = await this.pedidoService.getOnePedidoRastreador(id).toPromise();
				if (pedido) {
					this.pedido = pedido.data;
					this.selectedCliente = pedido.data.cliente[0];
					this.termoPesquisa = pedido.data.cliente[0].nome_fantasia;
					this.itensPedidoProduto = pedido.data.produtos.map(produto => ({
						quantidade: produto.quantidade,
						id_rastreador_modelo: Number(produto.id_rastreador_modelo),
						itemValor: produto.vl_negociado,
						modelo: produto.modelo
					}));
					this.selectedVendedor = this.vendedores.find(v => v.id_usuario === pedido.data.id_vendedor);
					this.pedido.gerarNF = pedido.data.gerar_nf
					this.pedido.instalarPlataforma = pedido.data.plataforma_rastreei
					this.pedido.chipRastreei = pedido.data.chip_rastreei

					// Preencher o textarea com os IMEIs dos rastreadores
					if (pedido.data.rastreadores && pedido.data.rastreadores.length > 0) {
						this.imeisParaSeparacao = pedido.data.rastreadores.map(r => r.imei).join('\n');
					}

					this.form.patchValue({
						dt_contrato: pedido.data.dt_contrato ? new Date(pedido.data.dt_contrato) : null,
						dt_fidelidade: pedido.data.dt_fidelidade ? new Date(pedido.data.dt_fidelidade) : null
					});
					// Set collapse states after pedido data is loaded
					// (4 = Em Separacao, 5 = Em Configuracao, 6 = Pronto para Envio, 7 = Enviado)
					if (this.pedido.id_status == 4) {
						this.isPedidoCollapsed = true;
						this.isSeparacaoCollapsed = false;
						this.isConfiguracaollapsed = false;
						this.isEnvioProntoCollapsed = true;
					} else if (this.pedido.id_status == 5) {
						this.isPedidoCollapsed = true;
						this.isSeparacaoCollapsed = true;
						this.isConfiguracaollapsed = false;
						this.isEnvioProntoCollapsed = true;
					} else if (this.pedido.id_status == 6) {
						this.isPedidoCollapsed = true;
						this.isSeparacaoCollapsed = true;
						this.isConfiguracaollapsed = true;
						this.isEnvioProntoCollapsed = false;
					} else {
						this.isPedidoCollapsed = false;
						this.isSeparacaoCollapsed = false;
						this.isConfiguracaollapsed = false;
						this.isEnvioProntoCollapsed = false;
					}

					// Generate QR code URL
					this.generateQRCode();
				}
			} catch (error) {
				console.error('Erro ao carregar pedido:', error);
			}
		}

		try {
			const modelos = await this.rastreadorModeloService.findAll();
			if (modelos.length > 0) {
				this.modelosRastreador = modelos;
			}
		} catch (error) {
			console.error('Erro ao carregar modelos de rastreador:', error);
		}

		this.contentHeader = {
			headerTitle: this.pedido.id_pedido ? "Gerenciar Pedido" : "Novo Pedido",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Pedido",
						isLink: false,
					},
					{
						name: this.pedido.id_pedido ? "Gerenciar" : "Novo",
						isLink: false,
					},
				],
			},
		};

		// Get the current page URL
		this.currentPageUrl = window.location.href;

		// Buscar configurações se houver um ID de pedido
		if (this.idComponet) {
			this.pedidoService.getConfiguracoes(this.idComponet).subscribe(
				(response) => {
					if (response?.data) {
						this.necessitaConfiguracao = response.data.plataforma == null && response.data.chip == null ? false : true;
						console.log(this.necessitaConfiguracao);
						
						this.configuracao = {
							plataforma: response.data.plataforma != null ? 'outra' : 'rastreei',
							plataformaConfig: response.data.plataforma || {
								dominio: '',
								porta: ''
							},
							chip: response.data.chip != null ? 'outra' : 'rastreei',
							chipConfig: response.data.chip || {
								dominio: '',
								usuario: '',
								senha: ''
							}
						};
					}
				},
				(error) => {
					console.error('Erro ao buscar configurações:', error);
				}
			);
		}
	}

	ngOnChanges(changes) {
		// changes.prop contains the old and the new value...
	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	gerarContrato() {
		this.contrato['id_pedido'] = this.pedido.id_pedido;

		Swal.fire({
			title: "Confirmação",
			text: "Deseja aprovar o pagamento do pedido?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: '#161D31',
			cancelButtonColor: '#6e7d88',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then((result) => {
			if (result.isConfirmed) {
				this.pedidoService.aprovarPagamento({ id_pedido: this.idComponet }).subscribe(
					(res) => {
						window.location.reload();
					},
					(error) => {
						console.log(error);
						this.loading = false;
						Swal.fire({
							title: "Erro!",
							text: "Ocorreu um erro interno.",
							icon: "error",
							confirmButtonText: "Confirmar",
							confirmButtonColor: '#ef6767',
						});
					}
				);
			}
		});

	}

	efetuarPedido(isContrato) {
		if (isContrato) {
			if (this.form.status == 'INVALID') {
				this.loading = false;
				Swal.fire({
					title: "Insira as datas de fidelidade e contrato!",
					icon: "error",
					confirmButtonText: "Confirmar",
					confirmButtonColor: '#ef6767',
				});
				return
			}
		}

		Swal.fire({
			title: "Confirmação",
			text: isContrato ? "Deseja Gerar o contrato do pedido?" : "Deseja efetuar o pedido?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: '#161D31',
			cancelButtonColor: '#6e7d88',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then((result) => {
			if (result.isConfirmed) {
				this.erro = false;
				// this.loading = true;

				if (this.selectedCliente != null) {

					if (!this.pedido.id_pedido) {

						const pedidoData = {
							cliente: this.selectedCliente,
							vendedor: this.selectedVendedor,
							produtos: this.itensPedidoProduto.map(item => ({
								quantidade: item.quantidade,
								id_rastreador_modelo: item.id_rastreador_modelo,
								itemValor: item.itemValor
							})),
							gerarNF: this.pedido.gerarNF,
							instalarPlataforma: this.pedido.instalarPlataforma,
							chipRastreei: this.pedido.chipRastreei
						};

						this.pedidoService.createPedidoRastreador(pedidoData).subscribe(
							(res) => {
								window.location.href = '/pedido-rastreador';
							},
							(error) => {
								console.log(error);
								this.loading = false;
								Swal.fire({
									title: "Erro!",
									text: "Ocorreu um erro interno.",
									icon: "error",
									confirmButtonText: "Confirmar",
									confirmButtonColor: '#ef6767',
								});
							}
						);
					} else {
						const updateData = {
							id_cliente: this.selectedCliente.id_cliente,
							id_vendedor: this.selectedVendedor.id,
							gerarNF: this.pedido.gerarNF,
							instalarPlataforma: this.pedido.instalarPlataforma,
							chipRastreei: this.pedido.chipRastreei
						};
						this.pedidoService.put(updateData, this.pedido.id_pedido).subscribe(
							(res) => {

								this.itensPedidoProduto.forEach(element => {

									this.arrayPost.push({
										id_pedido: res.id_pedido,
										id_pedido_item: Number(element.IdPedidoItem),
										quantidade: element.quantidade,
										id_plano: Number(element.itemPlanoId),
										vl_negociado: Number(element.itemValor),
										id_tipo_item: Number(element.itemTipo)
									})
								});

								this.pedidoItemService.put(this.arrayPost, this.pedido.id_pedido).subscribe(
									(itemPedidoRes) => {
										if (itemPedidoRes != null) {
											this.loading = false;

											if (isContrato) {

												this.loadingContrato = true;
												this.loading = true;
												// this.contrato.dt_contrato = moment(this.contrato.dt_contrato, 'DD-MM-YYYY').format('YYYY-MM-DD');
												this.contrato.dt_fidelidade = moment(this.contrato.dt_fidelidade, 'DD-MM-YYYY').format('YYYY-MM-DD');

												// let contrato: ContratoInterface = {
												// 	id_contrato: null,
												// 	id_tipo: 2,
												// 	id_status: Number(this.pedido.id_status),
												// 	id_plano: null,
												// 	id_pedido: Number(this.pedido.id_pedido),
												// 	id_cliente: Number(this.pedido.id_cliente),
												// 	num_contrato: this.pedido.num_pedido,
												// 	dt_fidelidade: this.contrato.dt_fidelidade,
												// 	dt_contrato: this.contrato.dt_contrato,
												// 	dt_insert: null,
												// }

												// this.contratoService.post(contrato).subscribe(
												// 	(resContrato) => {
												// 		if (resContrato) {
												// 			let sendContratoItem = []
												// 			this.itensPedidoProduto.forEach(item => {
												// 				sendContratoItem.push({
												// 					id_contrato_item: null,
												// 					id_contrato: resContrato.id_contrato,
												// 					id_operadora: item.itemPlanoId,
												// 					id_broker: item.itemPlanoBrokerId,
												// 					id_plano: item.itemPlanoId,
												// 					valor_reativacao: item.itemPlanoVlReativacao,
												// 					valor_ativacao: item.itemPlanoVlAtivacao,
												// 					valor_cancelar: item.itemPlanoVlCancelar,
												// 					valor_mensal: item.itemValor,
												// 					id_tipo_item: item.itemTipo,
												// 					quantidade: item.quantidade
												// 				})
												// 			});
												// 			this.contratoItemService.post(sendContratoItem).subscribe(
												// 				(resContratoItem) => {
												// 					this.loadingContrato = false;
												// 					this.loading = false;
												// 					Swal.fire({
												// 						title: "Contrato Gerado!",
												// 						text: `Contrato gerado com sucesso`,
												// 						icon: "success",
												// 						confirmButtonText: "Confirmar",
												// 						confirmButtonColor: '#161D31',
												// 					}).then(() => {
												// 						this._router.navigate(['pedido']);
												// 					});

												// 				},
												// 				(err) => {
												// 					console.log(err);
												// 					this.loadingContrato = false;
												// 					this.loading = false;
												// 					Swal.fire({
												// 						title: "Erro!",
												// 						text: "Ocorreu um erro interno.",
												// 						icon: "error",
												// 						confirmButtonText: "Confirmar",
												// 						confirmButtonColor: '#ef6767',
												// 					});
												// 				}
												// 			)
												// 		}

												// 	},
												// 	(err) => {
												// 		console.log(err);
												// 		this.loadingContrato = false;
												// 		this.loading = false;
												// 		Swal.fire({
												// 			title: "Erro!",
												// 			text: "Ocorreu um erro interno.",
												// 			icon: "error",
												// 			confirmButtonText: "Confirmar",
												// 			confirmButtonColor: '#ef6767',
												// 		});
												// 	}
												// );
											} else {
												Swal.fire({
													title: "Pedido atualizado!",
													text: `Pedido atualizado com sucesso`,
													icon: "success",
													confirmButtonText: "Confirmar",
													confirmButtonColor: '#161D31',
												}).then(() => {
													window.location.href = '/pedido-rastreador';
												});
											}
										}
									},
									(error) => {
										console.log(error);
										this.loading = false;
										Swal.fire({
											title: "Erro!",
											text: "Ocorreu um erro interno.",
											icon: "error",
											confirmButtonText: "Confirmar",
											confirmButtonColor: '#ef6767',
										});
									}
								);
							},
							(err) => {
								console.log(err);
								this.loading = false;
							}
						);
					}


				} else {
					this.loading = false;
					this.erroPreenchimento()
				}
			}
		});

	}

	erroPreenchimento() {
		this.loading = false;
		Swal.fire({
			title: "Preencha todos os campos corretamente!",
			icon: "error",
			confirmButtonText: "Confirmar",
			confirmButtonColor: '#ef6767',
		});
	}

	textFilter(event, param) {
		const val = event.target.value.toLowerCase();
		// filter our data
		const temp = this.temp.filter(function (d) {
			return d[param].toLowerCase().indexOf(val) !== -1 || !val;
		});
		// update the rows
		this.planos = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
	}

	valorFilter(event) {
		const val = event.target.value.toLowerCase();
		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.valor.toLowerCase().indexOf(val) !== -1 || !val && d.percentual.toLowerCase().indexOf(val) !== -1 || !val;
		});
		// update the rows
		this.planos = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
	}

	onKeyUp(event: any) {
		this.carregando = true;
		this.clienteNaoEncontrado = false

		const termoPesquisa = event.target.value.toLowerCase();
		clearTimeout(this.timer);

		this.timer = setTimeout(() => {
			this.clientes = [];
			this.clienteService.pesquisa(termoPesquisa).subscribe((res) => {
				if (res[0].length > 0) {
					let temp = res[0];
					temp.forEach(element => {
						let option = { 'id_cliente': element.id_cliente, 'email_cliente': element.email_cliente, 'razao_social': element.razao_social, 'nome_fantasia': element.nome_fantasia, 'nome_contratante': element.nome_contratante, 'nome': element.nome_fantasia.toUpperCase() + ' | ' + element.cpf_cnpj_cliente };
						this.clientes.push(option);
					});
					this.carregando = false;
				} else {
					this.carregando = false;
					this.clienteNaoEncontrado = true
				}
			},
				(error) => {
					error
					this.carregando = false;
				}
			);

		}, 2000);
	}

	setCliente(cliente) {
		this.selectedCliente = cliente;
	}

	modalPlanoOpen(modalBasic, item) {
		this.indexItem = item;
		this.modalService.open(modalBasic, {
			windowClass: 'modal',
			size: 'xl',
			centered: true
		});
	}

	visualizarValoresTabela(modalBasic, itens) {
		this.itensModal = itens
		this.modalService.open(modalBasic, {
			windowClass: 'modal',
			size: 'xl',
			centered: true
		});
	}

	modalTabelasOpen(modalBasic, item) {
		this.indexItem = item;
		this.modalService.open(modalBasic, {
			windowClass: 'modal',
			size: 'xl',
			centered: true
		});
	}

	modalDescontoOpen(modalBasicDesconto, item) {
		this.indexItem = item;
		this.modalService.open(modalBasicDesconto, {
			windowClass: 'modal',
			size: 'lg',
			centered: true
		});
	}

	definirTabela(tabela) {
		this.modalService.dismissAll();
		this.itensPedidoServico[this.indexItem].tabelaSelecionada = tabela;
	}

	selectPlano(row) {
		this.modalService.dismissAll();
		this.itensPedidoProduto[this.indexItem].itemPlanoId = row.id_plano
		this.itensPedidoProduto[this.indexItem].itemPlanoNome = row.plano
		this.itensPedidoProduto[this.indexItem].itemValor = row.valor_mensal
		this.itensPedidoProduto[this.indexItem].itemPlanoBroker = row.nome_broker
		this.itensPedidoProduto[this.indexItem].itemPlanoOperadora = row.nome_operadora
		this.itensPedidoProduto[this.indexItem].itemPlanoPacote = row.pacote
		this.alterarTotal()
	}

	removerDesconto(id_desconto) {
		this.desconto_selecionado.forEach((desconto, index) => {
			if (desconto.descontoId === id_desconto) {
				this.desconto_selecionado.splice(index, 1);
			}
		});
		this.alterarTotal();
	}

	selectDesconto(row) {
		this.modalService.dismissAll();
		this.desconto_selecionado.push({
			descontoId: row.id_desconto,
			desconto: row.desconto,
			descontoValor: row.valor,
			descontoPercentual: row.percentual,
			descontoTempo: row.tempo,
			descontoTipo: row.id_tipo_desconto
		})
		this.alterarTotal();
	}

	addItem() {
		this.itensPedidoProduto.push({
			id_rastreador_modelo: null,
			modelo: null,
			itemValor: null,
			quantidade: null
		});
	}

	addItemProdutoServico() {
		let o = {
			quantidade: null,
			itemTipo: null,
			itemPlanoId: null,
			itemValor: null,
			itemPlanoNome: null,
			itemPlanoVlAtivacao: null,
			itemPlanoVlCancelar: null,
			itemPlanoVlReativacao: null,
			itemPlanoBroker: null,
			itemPlanoBrokerId: null,
			itemPlanoOperadora: null,
			itemPlanoPacote: null,
			itemDescontos: [],
			IdPedidoItem: null,
			condicaoSelected: '1',
			itemValorMinimo: null,
			tabelaSelecionada: null,
			servicoSelecionado: null,
			nomeTipoItem: null
		};
		this.itensPedidoServico = [...this.itensPedidoServico, o];
	}

	alterarCondicaoSelecionda(item, i) {
		this.itensPedidoServico[i].condicaoSelected = item;
	}

	deleteItem(id) {
		for (let i = 0; i < this.itensPedidoProduto.length; i++) {
			if (this.itensPedidoProduto.indexOf(this.itensPedidoProduto[i]) === id) {
				this.itensPedidoProduto.splice(i, 1);
				break;
			}
		}
		this.alterarTotal()
	}

	deleteItemProdutoServico(id) {
		for (let i = 0; i < this.itensPedidoServico.length; i++) {
			if (this.itensPedidoServico.indexOf(this.itensPedidoServico[i]) === id) {
				this.itensPedidoServico.splice(i, 1);
				break;
			}
		}
		this.alterarTotal()
	}


	selectItem(event, index) {
		const selectedValue = event.target.value;
		this.itensPedidoProduto[index].id_rastreador_modelo = selectedValue;
		// Atualiza o nome do modelo selecionado
		const modeloSelecionado = this.modelosRastreador.find(modelo => modelo.id_rastreador_modelo == selectedValue);
		this.itensPedidoProduto[index].modelo = modeloSelecionado ? modeloSelecionado.nome : null;
	}


	selectItemTabelaPreco(item, index) {
		this.itensPedidoServico[index].condicaoSelected = item.target.value;
	}

	selecionarServico(item, index) {
		this.itensPedidoServico[index].servicoSelecionado = item.target.value;
		const pedidoObj = this.tipoItemServico.find(item => item.nome == this.itensPedidoServico[index].servicoSelecionado)
		this.itensPedidoServico[index].itemTipo = pedidoObj.id_servico
	}

	alterarTotal() {
		this.valorTotal = 0
		this.itensPedidoProduto.forEach(item => {
			this.valorTotal = this.valorTotal + (item.itemValor * item.quantidade)
		});
		this.itensPedidoServico.forEach(item => {
			this.valorTotal = this.valorTotal + (item.itemValor * item.quantidade)
		});
	}

	todosItensValidos(): boolean {
		return this.itensPedidoProduto.every(item =>
			item.quantidade > 0 &&
			item.itemValor > 0 &&
			item.id_rastreador_modelo != null
		);
	}

	confirmarSeparacao() {
		if (!this.imeisParaSeparacao || this.imeisParaSeparacao.trim() === '') {
			Swal.fire({
				title: "Erro!",
				text: "Por favor, insira os IMEIs dos rastreadores.",
				icon: "error",
				confirmButtonText: "OK",
				confirmButtonColor: '#ef6767',
			});
			return;
		}

		// Parse the IMEIs, splitting by newline
		const imeis = this.imeisParaSeparacao.trim().split('\n')
			.map(imei => imei.trim())
			.filter(imei => imei !== '');

		if (imeis.length === 0) {
			Swal.fire({
				title: "Erro!",
				text: "Por favor, insira IMEIs válidos.",
				icon: "error",
				confirmButtonText: "OK",
				confirmButtonColor: '#ef6767',
			});
			return;
		}

		Swal.fire({
			title: "Confirmar Separação",
			text: `Você está prestes a separar ${imeis.length} rastreadores para este pedido. Deseja continuar?`,
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim, confirmar",
			cancelButtonText: "Cancelar",
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
		}).then((result) => {
			if (result.isConfirmed) {
				this.loading = true;

				this.pedidoService.confirmarSeparacao(this.pedido.id_pedido, imeis).subscribe(
					(response) => {
						if (response.data.message == 'Nem todos os IMEIs foram encontrados no sistema') {
							this.loading = false;
							Swal.fire({
								title: "Erro!",
								text: "IMEIs não encontrados: " + response.data.imeisFaltantes.join(', '),
								icon: "error",
								confirmButtonText: "OK",
								confirmButtonColor: '#ef6767',
							});
						} else {
							this.loading = false;
							Swal.fire({
								title: "Separação Confirmada!",
								text: "Os rastreadores foram separados com sucesso.",
								icon: "success",
								confirmButtonText: "OK",
								confirmButtonColor: '#161D31',
							}).then(() => {
								// Reload the current page instead of navigating
								window.location.reload();
							});
						}
					},
					(error) => {
						this.loading = false;
						console.error('Erro ao confirmar separação:', error);

						Swal.fire({
							title: "Erro!",
							text: "Ocorreu um erro ao processar a separação. Por favor, tente novamente.",
							icon: "error",
							confirmButtonText: "OK",
							confirmButtonColor: '#ef6767',
						});
					}
				);
			}
		});
	}

	generateQRCode() {
		// This method is no longer needed since we're using the currentPageUrl directly
		// But we'll keep it for backward compatibility
		this.currentPageUrl = window.location.href;
	}

	contarImeis(): number {
		if (!this.imeisParaSeparacao) {
			return 0;
		}
		return this.imeisParaSeparacao.split('\n').filter(line => line.trim() !== '').length;
	}

	imprimirEtiqueta() {
		if (!this.pedido || !this.pedido.num_pedido) {
			Swal.fire({
				title: "Erro!",
				text: "Não foi possível gerar a etiqueta: número do pedido não disponível",
				icon: "error",
				confirmButtonText: "OK",
				confirmButtonColor: '#ef6767',
			});
			return;
		}

		// Use the current page URL
		const currentPageUrl = window.location.href;

		// Generate QR code using QR Server API
		const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(currentPageUrl)}`;

		// Create a new window for printing
		const printWindow = window.open('', '_blank');

		// Generate HTML content for the print window
		printWindow.document.write(`
			<!DOCTYPE html>
			<html>
			<head>
				<title>Etiqueta</title>
				<style>
					@page {
						margin: 0;
						size: A4;
					}
					body {
						font-family: Arial, sans-serif;
						margin: 10mm;
						padding: 0;
					}
					.etiqueta {
						display: flex;
						flex-direction: column;
						align-items: center;
						text-align: center;
					}
					.cliente {
						font-size: 24pt;
						font-weight: bold;
						margin-bottom: 10mm;
						width: 100%;
						text-align: center;
					}
					@media print {
						body {
							margin: 10mm;
						}
					}
				</style>
			</head>
			<body>
				<div class="etiqueta">
					<div class="cliente">
						${this.selectedCliente ? this.pedido.num_pedido : 'Cliente'}
					</div>
					<div>
						<img src="${qrCodeUrl}" alt="QR Code" style="width: 400px; height: 400px;">
					</div>
				</div>
				<script>
					window.onload = function() {
						setTimeout(function() {
							window.print();
						}, 1000);
					}
				</script>
			</body>
			</html>
		`);

		printWindow.document.close();
	}

	confirmarEnvio() {
		Swal.fire({
			title: "Confirmar Envio",
			text: "Você está prestes a confirmar o envio deste pedido. O pedido realmente foi postado nos correios?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim, confirmar",
			cancelButtonText: "Cancelar",
			confirmButtonColor: '#3085d6',
		}).then((result) => {
			if (result.isConfirmed) {
				this.loading = true;
				if (result.isConfirmed) {
					this.pedidoService.confirmarEnvio({ id_pedido: this.idComponet }).subscribe(
						(res) => {
							window.location.reload();
						},
						(error) => {
							console.log(error);
							this.loading = false;
							Swal.fire({
								title: "Erro!",
								text: "Ocorreu um erro interno.",
								icon: "error",
								confirmButtonText: "Confirmar",
								confirmButtonColor: '#ef6767',
							});
						}
					);
				}
			}
		});
	}

	isConfiguracaoValida(): boolean {
		if (!this.necessitaConfiguracao) return true;
		
		// Validação básica da configuração
		if (!this.configuracao.plataforma || !this.configuracao.chip) return false;
		
		// Validação dos campos adicionais da plataforma
		if (this.configuracao.plataforma === 'outra') {
			if (!this.configuracao.plataformaConfig.dominio || 
				!this.configuracao.plataformaConfig.porta) {
				return false;
			}
		}
		
		// Validação dos campos adicionais do chip
		if (this.configuracao.chip === 'outra') {
			if (!this.configuracao.chipConfig.dominio || 
				!this.configuracao.chipConfig.usuario || 
				!this.configuracao.chipConfig.senha) {
				return false;
			}
		}
		
		return true;
	}

	confirmarConfiguracao() {
		if (!this.isConfiguracaoValida()) {
			Swal.fire({
				title: "Erro!",
				text: "Por favor, preencha todos os campos de configuração necessários.",
				icon: "error",
				confirmButtonText: "OK",
				confirmButtonColor: '#ef6767',
			});
			return;
		}

		Swal.fire({
			title: "Confirmar Configuração",
			text: "Você está prestes a confirmar a configuração deste pedido. Deseja continuar?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim, confirmar",
			cancelButtonText: "Cancelar",
			confirmButtonColor: '#3085d6',
		}).then((result) => {
			if (result.isConfirmed) {
				this.loading = true;
				
				const configData = {
					id_pedido: this.idComponet,
					necessita_configuracao: this.necessitaConfiguracao,
					plataforma: this.configuracao.plataforma,
					plataforma_config: this.configuracao.plataforma === 'outra' ? this.configuracao.plataformaConfig : null,
					chip: this.configuracao.chip,
					chip_config: this.configuracao.chip === 'outra' ? this.configuracao.chipConfig : null
				};

				this.pedidoService.confirmarConfiguracao(configData).subscribe(
					(res) => {
						window.location.reload();
					},
					(error) => {
						console.log(error);
						this.loading = false;
						Swal.fire({
							title: "Erro!",
							text: "Ocorreu um erro interno.",
							icon: "error",
							confirmButtonText: "Confirmar",
							confirmButtonColor: '#ef6767',
						});
					}
				);
			}
		});
	}
}